<template>
  <div id="app">
    <v-app id="inspire">
      <v-card v-model="show" color="#FFFF99">
        <v-card-title>
          <v-icon large left>mdi-wrench-clock</v-icon>
          <h6>Posventa - Listado</h6>
        </v-card-title>
        <v-card-text class="pt-2">
          <v-row dense>
            <v-col cols="6" sm="4" md="2">
              <v-select dense v-model="filtroestado" :items="estado" label="Estado" item-text="detalle"
                item-value="valor"></v-select>
            </v-col>
            <v-col cols="6" sm="6" md="2">
              <v-text-field label="Filtro por N° SPV" dense v-model="filtrocodgral">
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="2">
              <v-text-field label="Filtro por N° OT" dense v-model="filtronumot">
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="2">
              <v-text-field label="Filtro por N° Serie" dense v-model="filtronumserie">
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="2">
              <v-text-field label="Filtro por N° NP" dense v-model="filtronumnp">
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="4" md="2">
              <v-select dense v-model="filtroinvolucra" :items="involucra" label="Involucra" item-text="detalle"
                item-value="valor"></v-select>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6" sm="6" md="2">
              <v-select dense v-model="filtrosector" :items="sector" label="Sector" item-text="detalle"
                item-value="valor"></v-select>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-text-field label="Filtro por Cliente" dense v-model="filtrocliente">
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="2">
              <v-select dense v-model="filtrotipo" :items="tipo" label="Especificación" item-text="detalle"
                item-value="valor"></v-select>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-text-field label="Filtro por Referencia" dense v-model="filtroreferencia">
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="2">
              <v-text-field label="Filtro por Responsable Comercial" dense v-model="filtrorespcom">
              </v-text-field>
            </v-col>
          </v-row>
          <v-row align="center" justify="space-around">
            <v-btn tile color="success" @click="cargarListados()">
              <v-icon left> mdi-magnify </v-icon>
              Buscar
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>

      <v-data-table dense :headers="headersP" :items="listadoP" :loading="loadtable"
        no-data-text="No hay datos disponibles" loading-text="Cargando... Espere por favor" :single-expand="true"
        locale="es-ar" class="elevation-1" show-expand :items-per-page="200" :footer-props="{
          itemsPerPageText: 'SPV por página',
        }">
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            Último seguimiento: {{ item.descripultseg }}
          </td>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small color="blue" class="mr-2" v-on="on" v-bind="attrs" @click.stop="verPosventa(item)">
                mdi-eye
              </v-icon>
            </template>
            <span>ver SPV</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <VerPosventa :visible="showPosventa" :codgral="editedItem.codgral" @close="showPosventa = false"></VerPosventa>
    </v-app>
  </div>
</template>

<script>
import axios from "../../../axios-auth";
import VerPosventa from "../Posventa/Informe.vue";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
  components: { VerPosventa },
  data: (vm) => ({
    editedItem: {},
    editedIndex: -1,
    filtroestado: "Todos",
    // filtroestado: [
    // { detalle: "Todos", valor: "Todos" },
    // ],
    filtrocodgral: "",
    filtroinvolucra: [],
    filtronumnp: "",
    filtronumot: "",
    filtronumserie: "",
    filtrotipo: "",
    filtrorespcom: "",
    filtrocliente: "",
    filtroreferencia: "",
    filtrosector: "",
    listadoP: [],
    showPosventa: false,
    loadtable: false,
    estado: [
      { detalle: "Todos", valor: "Todos" },
      { detalle: "Pendiente Ejecución", valor: "Nuevo" },
      { detalle: "Pendiente Comité", valor: "Pendiente" },
      { detalle: "Cerrado", valor: "Cerrado" },
    ],
    involucra: [
      { detalle: "Producto de terceros", valor: "P" },
      { detalle: "Fabricación", valor: "F" },
      { detalle: "Obra", valor: "O" },
    ],
    sector: [
      { detalle: "Comercial", valor: "CO" },
      { detalle: "Ingeniería de Obra", valor: "IO" },
      { detalle: "Ingeniería de Producto", valor: "IP" },
      { detalle: "Abastecimiento", valor: "AB" },
      { detalle: "Fabricación", valor: "FA" },
      { detalle: "Proveedor", valor: "PR" },
      { detalle: "Cliente", valor: "CL" },
      { detalle: "Depósito", valor: "DE" },
      { detalle: "Inspección y Ensayo", valor: "CA" },
      { detalle: "Control de Gestión", valor: "CG" },
      { detalle: "Administración", valor: "AD" },
      { detalle: "Todos", valor: "" },
    ],
    tipo: [
      { detalle: "Asistencia Técnica / Capacitación", valor: "asistencia_tecnica" },
      { detalle: "Mantenimiento", valor: "mantenimiento" },
      { detalle: "Garantía", valor: "Garantia" },
      { detalle: "Fuera de Garantía", valor: "fuera_garantia" },
      { detalle: "Todos", valor: "" },
    ],
    headersP: [
      {
        text: "Código",
        align: "start",
        sortable: false,
        value: "codgral",
      },
      { text: "Cliente", value: "cliente", sortable: false },
      { text: "Tipo", value: "tipo", sortable: false },
      { text: "Referencia", value: "referencia", sortable: false },
      { text: "Elaboró", value: "respCom", sortable: false },
      { text: "Fecha", value: "fecha", sortable: false },
      {
        text: "Fecha últ. seg./ Fecha cierre",
        value: "fechaultseg",
        sortable: false,
      },
      { text: "N° OT", value: "numot", sortable: false },
      { text: "Sector", value: "sector", sortable: false },
      { text: "", value: "data-table-expand" },
      { text: "Acciones", value: "actions", align: "center", sortable: false },
    ],
  }),

  computed: {
    show: {
      get() {
        // this.cargarListados();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    cargarListados() {
      this.vaciarModels();
      this.loadtable = true;
      const respcom = this.filtrorespcom;
      const sector = this.filtrosector;
      const cliente = this.filtrocliente;
      const referencia = this.filtroreferencia;
      const tipo = this.filtrotipo;
      const estado = this.filtroestado;
      const involucra = this.filtroinvolucra;
      const numot = this.filtronumot;
      const numnp = this.filtronumnp;
      const numserie = this.filtronumserie;
      const codgral = this.filtrocodgral;

      let self = this;

      axios
        .get("/App/ListadoPosventa?", {
          params: {
            respcom: respcom,
            sector: sector,
            cliente: cliente,
            referencia: referencia,
            tipo: tipo,
            estado: estado,
            involucra: involucra,
            numnp: numnp,
            numot: numot,
            numserie: numserie,
            codgral: codgral,
          },
        })
        .then((response) => {
          self.listadoP = response.data;
          self.loadtable = false;
          //self.listadoP = response.data;
        })
        .catch((error) => {
          self.listadoP = [];
          console.log(error);
        });
    },
    verPosventa(item) {
      this.editedIndex = this.listadoP.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showPosventa = true;
    },
    vaciarModels() {
      this.listadoP = [];
    },
  },
};
</script>
